'use client';

import dynamic from 'next/dynamic';

import { Modal } from '../Modal';
import { Loader } from '../profile/LoaderWrapper';
import { useDialogs, useDialogsPreloading } from './hooks';
import { Modals } from '@/helpers/modals';

const PRELOADED_MODALS = [Modals.Registration, Modals.Login];

export const Dialogs = () => {
  const { modal } = useDialogs();
  const modalsCache = useDialogsPreloading(PRELOADED_MODALS);

  if (modal) {
    if (!modalsCache.has(modal)) {
      modalsCache.set(
        modal,
        dynamic(() => import(`@/components/dialogs/${modal}`), {
          ssr: false,
          loading: () => <Loader size={50} />,
        })
      );
    }

    const Component = modalsCache.get(modal)!;

    return (
      <Modal>
        <Component />
      </Modal>
    );
  }
  return null;
};
